import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import { teacherPlanner } from "../../../configs/WebService";

export const parseSyllabusExcel = createAsyncThunk(
  "syllabus/parseExcel",
  async (file, thunkAPI) => {
    const XLSX = await import("xlsx");

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        // Convert Excel date serials to readable format
        const convertedData = jsonData.map((row) => {
          const newRow = { ...row };
          if (newRow.Date && typeof newRow.Date === "number") {
            const excelEpoch = new Date(1900, 0, newRow.Date - 1);
            newRow.Date = excelEpoch.toISOString().split("T")[0]; // format: YYYY-MM-DD
          }
          return newRow;
        });

        const tableData = convertedData.reduce((acc, cur) => {
          Object.entries(cur).forEach(([term, chapter], index) => {
            acc.push({
              term,
              chapter,
              id: acc.length + 1,
              termId: index === 0 ? 1 : 2,
            });
          });
          return acc;
        }, []);

        resolve({ convertedData, tableData });
      };
      reader.onerror = (err) => reject(err);
      reader.readAsArrayBuffer(file);
    });
  }
);


export const getSyllabusScheduleThunk = createAsyncThunk(
  "syllabus/getSyllabusSchedule",
  async (teacherId, { rejectWithValue }) => {
    try {

      const response = await axios.get(
        `${teacherPlanner}/syllabus-schedule/${teacherId}`,
        {
          headers: apiKeyHeader(),
          // params: {
          //   start_date: "2026-03-09",
          //   end_date: "2026-03-15"
          // }
        }
      );

      console.log("Syllabus Schedule:", response.data);

      return response.data;

    } catch (error) {
      console.error("Syllabus schedule fetch error:", error);

      return rejectWithValue(
        error.response?.data || "Failed to fetch syllabus schedule"
      );
    }
  }
);

export const submitSyllabusThunk = createAsyncThunk(
  "syllabus/submitSyllabus",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const state = getState();

      const workingDays = state.masterData.workingDays;
      const finalPayload = {
        ...payload,
        workingDays: workingDays,
      };

      const response = await axios.post(
        `${teacherPlanner}/create-syllabus`,
        finalPayload,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getSyllabusThunk = createAsyncThunk(
  "syllabus/getSyllabus",
  async (teacherId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${teacherPlanner}/syllabus/${teacherId}`,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const getSyllabusCountThunk = createAsyncThunk(
  "syllabus/syllabus-count",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${teacherPlanner}/syllabus-count`,
        { headers: apiKeyHeader() }
      );
      return response.data; // { syllabus_count: number }
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const shiftTopicThunk = createAsyncThunk(
  "topic/shiftTopic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${teacherPlanner}/shift-topic`,
        payload,
        { headers: apiKeyHeader() }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to shift topic"
      );
    }
  }
);